import { Table } from "antd";

import { formatPercent, formatTenure } from "./chartTheme";

// Below this many staff one leaver swings the rate by 20+ points.
const SMALL_TEAM = 5;

const num = (key) => (a, b) => (a[key] ?? -1) - (b[key] ?? -1);

const RateCell = ({ row, max }) => {
  if (row.turnover_rate === null) return <span className="ws-muted">-</span>;
  const width = max ? Math.max(4, (row.turnover_rate / max) * 100) : 0;
  return (
    <div className="ws-rate">
      <div className="ws-rate__track" aria-hidden="true">
        <div className="ws-rate__bar" style={{ width: `${width}%` }} />
      </div>
      <span className="ws-rate__value">{formatPercent(row.turnover_rate)}</span>
      {row.headcount < SMALL_TEAM && <span className="ws-rate__flag" title="Fewer than 5 staff: the rate moves a lot with one leaver">small team</span>}
    </div>
  );
};

/** Turnover per cost center for the selected period, worst first. All rows on
 *  one page. */
const CostCenterTurnoverTable = ({ rows }) => {
  const max = Math.max(0, ...(rows || []).map((r) => r.turnover_rate || 0));
  const columns = [
    { title: "Cost center", dataIndex: "name", fixed: "left", width: 190, sorter: (a, b) => a.name.localeCompare(b.name) },
    { title: "Headcount", dataIndex: "headcount", align: "right", sorter: num("headcount") },
    { title: "Hires", dataIndex: "hires", align: "right", sorter: num("hires") },
    { title: "Leavers", dataIndex: "leavers", align: "right", sorter: num("leavers") },
    { title: "Resigned", dataIndex: "resigned", align: "right", sorter: num("resigned") },
    { title: "Terminated", dataIndex: "terminated", align: "right", sorter: num("terminated") },
    { title: "Left < 3 mo", dataIndex: "early_leavers", align: "right", sorter: num("early_leavers") },
    {
      title: "Turnover / yr",
      dataIndex: "turnover_rate",
      width: 190,
      defaultSortOrder: "descend",
      sorter: num("turnover_rate"),
      render: (_, row) => <RateCell row={row} max={max} />,
    },
    {
      title: "Avg tenure",
      dataIndex: "average_tenure_months",
      align: "right",
      sorter: num("average_tenure_months"),
      render: (value) => formatTenure(value),
    },
  ];
  return (
    <Table
      className="ws-table"
      size="small"
      columns={columns}
      dataSource={rows || []}
      rowKey={(r) => r.id ?? "none"}
      pagination={false}
      scroll={{ x: "max-content" }}
      locale={{ emptyText: "No cost centers in this selection." }}
    />
  );
};

export default CostCenterTurnoverTable;
